import { InvoiceView } from "admin/src/server/mappers/invoice/invoice";
import { ApiResponse } from "admin/src/ui/types/common/api-response";
import { ApiMutationConfig, GetInvoice } from "api";
const ApplyPromoCode: ApiMutationConfig<
  ApiResponse<InvoiceView>,
  {
    societyId: string;
    profileId: string;
    productId: string;
    invoiceItemId: string;
    promoCodeKey: string;
  },
  Record<string, unknown>
> = {
  apiPath:
    "/api/v1/society/{societyId}/accounting/products/{productId}/invoice-item/{invoiceItemId}/apply-promo-code?promoCodeKey={promoCodeKey}",
  method: "POST",
  invalidates: [
    {
      baseQueryKey: GetInvoice.queryKey.baseQueryKey,
      dynamicQueryKey: ["societyId", "profileId", "invoiceId"],
      exact: false,
    },
  ],
};

export { ApplyPromoCode };
